import type { App } from 'vue';
import apiClient from '../shared/services/api-client.service';

export default {
    install(app: App) {
        app.config.globalProperties.$apiClient = apiClient;
    },
};
